// AUTO-GENERATED catalog: City Mattress (Simmons/Serta/Sealy) + Puffy.com. Per-size variant pricing.
export const CATALOG = [
 {
  "slug": "beautyrest-black-hybrid-series-three-xcs-medium-mattress",
  "name": "Beautyrest Black Hybrid Series Three XCS Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3449,
  "priceFrom": true,
  "sku": "BRB26HY-S3-TXLMM",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "Split-Head California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3449
   },
   "Queen": {
    "price": 3399,
    "compareAt": 3999
   },
   "Split-Head Queen": {
    "price": 3999,
    "compareAt": 4599
   },
   "King": {
    "price": 4099,
    "compareAt": 4699
   },
   "Split-Head King": {
    "price": 4699,
    "compareAt": 5299
   },
   "Split-Head California King": {
    "price": 4099,
    "compareAt": 4699
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-medium-mattress-by-simmons-2802925.jpg?v=1781205731",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-medium-mattress-by-simmons-2802925.jpg?v=1781205731",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-medium-mattress-by-simmons-5474042.jpg?v=1781205732",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-medium-mattress-by-simmons-8423392.jpg?v=1781205732",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-medium-mattress-by-simmons-6940428.jpg?v=1781205733"
  ],
  "description": "Balanced comfort. Adaptive support. Cool, restorative sleep. The Beautyrest Black® Series Three XCS Medium Hybrid Mattress delivers a true balance of comfort and support, combining gentle contouring with a responsive, supportive feel. It adapts to your body to relieve pressure while maintaining…"
 },
 {
  "slug": "beautyrest-black-series-three-medium-mattress",
  "name": "Beautyrest Black Series Three Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3449,
  "priceFrom": true,
  "sku": "BRB24-S3-TXLMM",
  "firmness": "Medium",
  "height": "15 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3449
   },
   "Full": {
    "price": 3129,
    "compareAt": 3729
   },
   "Queen": {
    "price": 3399,
    "compareAt": 3999
   },
   "King": {
    "price": 4199,
    "compareAt": 4799
   },
   "California King": {
    "price": 4199,
    "compareAt": 4799
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-742081.jpg?v=1774469025",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-742081.jpg?v=1774469025",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-9150526.jpg?v=1774510092",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7741867.jpg?v=1774510093",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Awaken refreshed, revitalized, and ready to tackle the day atop the Beautyrest Black® Series Three Medium Mattress, featuring balanced support and comfort perfect for any sleeper. Innovative Sleep Climate™ Technology keeps you cool above two layers of SurfaceTouch™ Gel Memory Foam and GelTouch®…"
 },
 {
  "slug": "beautyrest-black-hybrid-series-three-xcs-firm-mattress",
  "name": "Beautyrest Black Hybrid Series Three XCS Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3449,
  "priceFrom": true,
  "sku": "BRB26HY-S3-TXLFM",
  "firmness": "Firm",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "Split Head Queen",
   "King",
   "Split Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3449
   },
   "Queen": {
    "price": 3399,
    "compareAt": 3999
   },
   "Split Head Queen": {
    "price": 3999,
    "compareAt": 4599
   },
   "King": {
    "price": 4099,
    "compareAt": 4699
   },
   "Split Head King": {
    "price": 4699,
    "compareAt": 5299
   },
   "California King": {
    "price": 4099,
    "compareAt": 4699
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-firm-mattress-by-simmons-7498193.jpg?v=1781205731",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-firm-mattress-by-simmons-7498193.jpg?v=1781205731",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-firm-mattress-by-simmons-3085098.jpg?v=1781205731",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-firm-mattress-by-simmons-3272615.jpg?v=1781205732",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-firm-mattress-by-simmons-3090834.jpg?v=1781205733"
  ],
  "description": "Firm support. Precise alignment. Cool, uninterrupted rest. If you prefer a firmer, more supportive feel, the Beautyrest Black® Series Three XCS Firm Hybrid Mattress is designed to keep your body aligned while still delivering comfortable contouring. It adapts to your shape without excessive sink,…"
 },
 {
  "slug": "serta-iseries-nxg-2500-all-foam-plush-mattress",
  "name": "Serta iSeries NXG 2500 Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2199,
  "priceFrom": true,
  "sku": "ISER2500HY-TXLMM",
  "firmness": "Medium",
  "height": "12 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1899,
    "compareAt": 2199
   },
   "Full": {
    "price": 2049,
    "compareAt": 2349
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2499
   },
   "King": {
    "price": 2899,
    "compareAt": 3199
   },
   "California King": {
    "price": 2899,
    "compareAt": 3199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-medium-mattress-by-serta-6651298.jpg?v=1767148691",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-medium-mattress-by-serta-6651298.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-medium-mattress-by-serta-5735921.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-medium-mattress-by-serta-8362433.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-medium-mattress-by-serta-4939269.jpg?v=1767148691"
  ],
  "description": "Balanced comfort. Responsive support. Cooling performance. The Serta iSeries NXG 2500 Hybrid Medium mattress is designed for sleepers who want a versatile balance of cushioning comfort and supportive stability. Featuring a series of benefits for the sleep you want, it delivers immediate cooling,…"
 },
 {
  "slug": "beautytrest-tortuga-bay-medium-innerspring-mattress",
  "name": "Beautyrest Tortuga Bay Medium Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 700,
  "compareAt": 1100,
  "priceFrom": true,
  "sku": "TORTUGABAY-TMM",
  "firmness": "Medium",
  "height": "12 1/2\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 700,
    "compareAt": 1100
   },
   "Twin XL": {
    "price": 800,
    "compareAt": 1200
   },
   "Full": {
    "price": 800,
    "compareAt": 1200
   },
   "Queen": {
    "price": 800,
    "compareAt": 1200
   },
   "King": {
    "price": 1100,
    "compareAt": 1800
   },
   "California King": {
    "price": 1100,
    "compareAt": 1800
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-tortuga-bay-medium-innerspring-mattress-by-simmons-532418.jpg?v=1746105695",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-tortuga-bay-medium-innerspring-mattress-by-simmons-532418.jpg?v=1746105695",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-tortuga-bay-medium-innerspring-mattress-by-simmons-890922.jpg?v=1746105695",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-tortuga-bay-medium-innerspring-mattress-by-simmons-533185.jpg?v=1746105696",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-tortuga-bay-medium-innerspring-mattress-by-simmons-915253.jpg?v=1746105696"
  ],
  "description": "Balanced comfort. Everyday support. Rest that feels just right. The Beautyrest Tortuga Bay Medium Innerspring Mattress delivers the ideal balance of softness and support for all sleep styles. Designed for real life-and really great sleep-it combines a breathable quilted surface, contouring memory…"
 },
 {
  "slug": "beautyrest-black-series-three-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series Three Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 3849,
  "priceFrom": true,
  "sku": "BRB24-S3-TXLMPTM",
  "firmness": "Medium Pillow Top",
  "height": "16 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 3849
   },
   "Full": {
    "price": 3529,
    "compareAt": 4129
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4399
   },
   "King": {
    "price": 4599,
    "compareAt": 5199
   },
   "California King": {
    "price": 4599,
    "compareAt": 5199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-pillow-top-mattress-by-simmons-572743.jpg?v=1724390966",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-pillow-top-mattress-by-simmons-572743.jpg?v=1724390966",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-pillow-top-mattress-by-simmons-9859823.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-pillow-top-mattress-by-simmons-7739331.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-6093517.jpg?v=1774785012"
  ],
  "description": "The extra cushioning you love plus the balanced support you need- the Beautyrest Black® Series Three Medium Pillow Top Mattress transforms your nights into a haven of relaxation. Heat-dissipating Smart Climate™ Technology works above two layers of SurfaceTouch™ Gel Memory Foam and GelTouch® Foam to…"
 },
 {
  "slug": "sealy-posturepedic-r-spring-medina-soft-mattress",
  "name": "Sealy Posturepedic Spring Medina Soft Mattress",
  "brand": "sealy",
  "category": "mattresses",
  "price": 860,
  "compareAt": 1150,
  "priceFrom": true,
  "sku": "MEDINA-TSM",
  "firmness": "Plush",
  "height": "12\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 860,
    "compareAt": 1150
   },
   "Twin XL": {
    "price": 880,
    "compareAt": 1176
   },
   "Full": {
    "price": 950,
    "compareAt": 1300
   },
   "Queen": {
    "price": 1000,
    "compareAt": 1400
   },
   "King": {
    "price": 1400,
    "compareAt": 1860
   },
   "California King": {
    "price": 1400,
    "compareAt": 1860
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-6705103.jpg?v=1751373468",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-6705103.jpg?v=1751373468",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-2383133.jpg?v=1751373468",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-3467900.jpg?v=1751373468",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-2314500.jpg?v=1751373468"
  ],
  "description": "Comfort that feels familiar-in the best way. Searching for something soft that still has your back? This one checks all the boxes. The Sealy Posturepedic® Soft Innerspring Mattress has layers of comfy, body-hugging foam on top and targeted coils underneath that support your back where you need it…"
 },
 {
  "slug": "beautyrest-black-series-one-extra-firm-mattress",
  "name": "Beautyrest Black Series One Extra Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1449,
  "compareAt": 1749,
  "priceFrom": true,
  "sku": "BRB24-S1-TXLXFM",
  "firmness": "Extra Firm",
  "height": "13 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1449,
    "compareAt": 1749
   },
   "Full": {
    "price": 1729,
    "compareAt": 2029
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2199
   },
   "King": {
    "price": 2599,
    "compareAt": 2899
   },
   "California King": {
    "price": 2599,
    "compareAt": 2899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-extra-firm-mattress-by-simmons-864659.jpg?v=1713928223",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-extra-firm-mattress-by-simmons-864659.jpg?v=1713928223",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-extra-firm-mattress-by-simmons-3909627.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-extra-firm-mattress-by-simmons-2600438.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Crafted with precision and engineered for enduring support, the Beautyrest Black® Series One Extra Firm Mattress elevates your sleep experience to new heights. Dissipating body heat and relieving pressure points, Sleep Climate™ Technology combines with GentleSupport™ Foam and open-cell AirCool® HD…"
 },
 {
  "slug": "beautyrest-emerald-coast-medium-firm-innerspring-mattress-1",
  "name": "Beautyrest Emerald Coast Medium Firm Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1199,
  "compareAt": 1399,
  "priceFrom": true,
  "sku": "EMERALDCOAST-TMFM",
  "firmness": "Medium Firm",
  "height": "14 1/2\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1199,
    "compareAt": 1399
   },
   "Twin XL": {
    "price": 1229,
    "compareAt": 1429
   },
   "Full": {
    "price": 1279,
    "compareAt": 1479
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1499
   },
   "King": {
    "price": 1799,
    "compareAt": 1999
   },
   "California King": {
    "price": 1799,
    "compareAt": 1999
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-medium-firm-innerspring-mattress-by-simmons-371023.jpg?v=1746539657",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-medium-firm-innerspring-mattress-by-simmons-371023.jpg?v=1746539657",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-medium-firm-innerspring-mattress-by-simmons-673585.jpg?v=1746539657",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-971142.jpg?v=1746539660",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-medium-firm-innerspring-mattress-by-simmons-230604.jpg?v=1746539658"
  ],
  "description": "Elevated comfort. Refined support. A world-class sleep upgrade. Step up from the balanced comfort of the Tortuga Bay to a more tailored and resilient feel. The Beautyrest Emerald Coast Medium Firm Innerspring Mattress offers a sturdier, more supportive sleep surface while maintaining the same…"
 },
 {
  "slug": "beautyrest-black-series-three-firm-mattress",
  "name": "Beautyrest Black Series Three Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3449,
  "priceFrom": true,
  "sku": "BRB24-S3-TXLFM",
  "firmness": "Firm",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3449
   },
   "Full": {
    "price": 3129,
    "compareAt": 3729
   },
   "Queen": {
    "price": 3399,
    "compareAt": 3999
   },
   "King": {
    "price": 4199,
    "compareAt": 4799
   },
   "California King": {
    "price": 4199,
    "compareAt": 4799
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-mattress-by-simmons-498602.jpg?v=1713928246",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-mattress-by-simmons-498602.jpg?v=1713928246",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-mattress-by-simmons-6204851.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-mattress-by-simmons-7393096.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Experience supportive serenity with the pressure point relief of the Beautyrest Black® Series Three Firm Mattress. Crafted with high-quality materials and attention to detail, Sleep Climate™ Technology provides cooling heat dissipation above two layers of SurfaceTouch™ Gel Memory Foam that works…"
 },
 {
  "slug": "sealy-posturepedic-r-spring-medina-medium-mattress",
  "name": "Sealy Posturepedic Spring Medina Medium Mattress",
  "brand": "sealy",
  "category": "mattresses",
  "price": 860,
  "compareAt": 1150,
  "priceFrom": true,
  "sku": "MEDINA-TMM",
  "firmness": "Medium",
  "height": "12\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 860,
    "compareAt": 1150
   },
   "Twin XL": {
    "price": 880,
    "compareAt": 1176
   },
   "Full": {
    "price": 950,
    "compareAt": 1300
   },
   "Queen": {
    "price": 1000,
    "compareAt": 1400
   },
   "King": {
    "price": 1400,
    "compareAt": 1860
   },
   "California King": {
    "price": 1400,
    "compareAt": 1860
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-medium-mattress-by-sealy-4884253.jpg?v=1751373466",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-medium-mattress-by-sealy-4884253.jpg?v=1751373466",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-2383133.jpg?v=1751373468",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-soft-mattress-by-sealy-3467900.jpg?v=1751373468",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-spring-medina-medium-mattress-by-sealy-9157792.jpg?v=1751373466"
  ],
  "description": "Comfort that feels familiar-in the best way. If you’re looking for a comfy and supportive mattress, this one’s a winner. The Sealy Posturepedic® Medium Innerspring Mattress features coils that give your back extra support where it counts, while layers of gel-infused foam help relieve pressure and…"
 },
 {
  "slug": "beautyrest-emerald-coast-medium-firm-innerspring-mattress",
  "name": "Beautyrest Emerald Coast Plush Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1199,
  "compareAt": 1399,
  "priceFrom": true,
  "sku": "EMERALDCOAST-TPLM",
  "firmness": "Plush",
  "height": "14 3/4\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1199,
    "compareAt": 1399
   },
   "Twin XL": {
    "price": 1229,
    "compareAt": 1429
   },
   "Full": {
    "price": 1279,
    "compareAt": 1479
   },
   "Queen": {
    "price": 1299,
    "compareAt": 1499
   },
   "King": {
    "price": 1799,
    "compareAt": 1999
   },
   "California King": {
    "price": 1799,
    "compareAt": 1999
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-innerspring-mattress-by-simmons-375096.jpg?v=1746539657",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-innerspring-mattress-by-simmons-375096.jpg?v=1746539657",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-innerspring-mattress-by-simmons-140877.jpg?v=1746539657",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-971142.jpg?v=1746539660",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-innerspring-mattress-by-simmons-284514.jpg?v=1746539658"
  ],
  "description": "Sumptuous comfort. Cooling serenity. A softer world-class experience. Step up from the supportive feel of the Emerald Coast Medium Firm to a more indulgent, body-cradling comfort. The Beautyrest Emerald Coast Plush Innerspring Mattress surrounds you in plush softness while maintaining the strength…"
 },
 {
  "slug": "beautyrest-black-series-two-medium-mattress",
  "name": "Beautyrest Black Series Two Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2449,
  "compareAt": 2749,
  "priceFrom": true,
  "sku": "BRB24-S2-TXLMM",
  "firmness": "Medium",
  "height": "15 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2449,
    "compareAt": 2749
   },
   "Full": {
    "price": 2729,
    "compareAt": 3029
   },
   "Queen": {
    "price": 2899,
    "compareAt": 3199
   },
   "King": {
    "price": 3599,
    "compareAt": 3899
   },
   "California King": {
    "price": 3599,
    "compareAt": 3899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-mattress-by-simmons-760532.jpg?v=1713928247",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-mattress-by-simmons-760532.jpg?v=1713928247",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-mattress-by-simmons-157437.jpg?v=1713928247",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-mattress-by-simmons-884779.jpg?v=1713928247",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-mattress-by-simmons-563497.jpg?v=1713928247"
  ],
  "description": "A perfect comfort feel for a wide range of sleepers, the Beautyrest Black® Series Two Medium Mattress keeps you cozy, cool, and supported all night. Including Smart Climate™ Technology to dissipate body heat with TENCEL® fibers, two separate layers of SurfaceTouch™ Gel Memory Foam offer premium…"
 },
 {
  "slug": "beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress",
  "name": "Beautyrest Emerald Coast Plush Pillow Top Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 1399,
  "compareAt": 1599,
  "priceFrom": true,
  "sku": "EMERALDCOAST-TPPTM",
  "firmness": "Plush Pillow Top",
  "height": "16\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1399,
    "compareAt": 1599
   },
   "Twin XL": {
    "price": 1429,
    "compareAt": 1629
   },
   "Full": {
    "price": 1479,
    "compareAt": 1679
   },
   "Queen": {
    "price": 1499,
    "compareAt": 1699
   },
   "King": {
    "price": 1999,
    "compareAt": 2199
   },
   "California King": {
    "price": 1999,
    "compareAt": 2199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-621922.jpg?v=1746539659",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-621922.jpg?v=1746539659",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-965224.jpg?v=1746539659",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-971142.jpg?v=1746539660",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-emerald-coast-plush-pillow-top-innerspring-mattress-by-simmons-318008.jpg?v=1746539660"
  ],
  "description": "Lavish softness. Deep relief. Plush comfort taken to the next level. Building on the gentle cushioning of the Emerald Coast Plush, the Beautyrest Emerald Coast Plush Pillow Top Innerspring Mattress introduces an even more indulgent layer of softness and contouring comfort. Its pillow top design…"
 },
 {
  "slug": "beautyrest-black-series-two-firm-mattress",
  "name": "Beautyrest Black Series Two Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2449,
  "compareAt": 2749,
  "priceFrom": true,
  "sku": "BRB24-S2-TXLFM",
  "firmness": "Firm",
  "height": "14 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2449,
    "compareAt": 2749
   },
   "Full": {
    "price": 2729,
    "compareAt": 3029
   },
   "Queen": {
    "price": 2899,
    "compareAt": 3199
   },
   "King": {
    "price": 3599,
    "compareAt": 3899
   },
   "California King": {
    "price": 3599,
    "compareAt": 3899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-firm-mattress-by-simmons-956500.jpg?v=1724390965",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-firm-mattress-by-simmons-956500.jpg?v=1724390965",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-firm-mattress-by-simmons-639636.jpg?v=1724694464",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-firm-mattress-by-simmons-699442.jpg?v=1724694464",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-firm-mattress-by-simmons-465585.jpg?v=1724694464"
  ],
  "description": "Upgrade your sleep experience with the supportive comfort of the Beautyrest Black® Series Two Firm Mattress, maintaining its shape and integrity. Cooling and revitalizing, Sleep Climate™ Technology effectively dissipates heat near the surface above the advanced pressure relief of Surface Touch™ Gel…"
 },
 {
  "slug": "serta-perfect-sleeper-coral-shores-quilted-firm-hybrid-mattress",
  "name": "Serta Perfect Sleeper Coral Shores Quilted Firm Hybrid Mattress",
  "brand": "serta-perfect-sleeper",
  "category": "mattresses",
  "price": 899,
  "compareAt": 1099,
  "priceFrom": true,
  "sku": "CORALSHORES-TXLFM",
  "firmness": "Firm",
  "height": "13 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 899,
    "compareAt": 1099
   },
   "Full": {
    "price": 1049,
    "compareAt": 1249
   },
   "Queen": {
    "price": 1199,
    "compareAt": 1399
   },
   "King": {
    "price": 1899,
    "compareAt": 2099
   },
   "California King": {
    "price": 1899,
    "compareAt": 2099
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-firm-hybrid-mattress-by-serta-721444.jpg?v=1747357697",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-firm-hybrid-mattress-by-serta-721444.jpg?v=1747357697",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-firm-hybrid-mattress-by-serta-555708.jpg?v=1747357697",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-firm-hybrid-mattress-by-serta-783943.jpg?v=1747357697",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-firm-hybrid-mattress-by-serta-807028.jpg?v=1747357697"
  ],
  "description": "Firm, cool, and supportive-at an approachable price point. The Coral Shores Quilted Firm Hybrid is crafted to deliver reliable support and cooling comfort night after night. Designed with five targeted support zones, this mattress keeps your spine aligned whether you sleep on your back or stomach.…"
 },
 {
  "slug": "serta-perfect-sleeper-coral-shores-quilted-plush-hybrid-mattress",
  "name": "Serta Perfect Sleeper Coral Shores Quilted Plush Hybrid Mattress",
  "brand": "serta-perfect-sleeper",
  "category": "mattresses",
  "price": 899,
  "compareAt": 1099,
  "priceFrom": true,
  "sku": "CORALSHORES-TXLPLM",
  "firmness": "Plush",
  "height": "13 3/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 899,
    "compareAt": 1099
   },
   "Full": {
    "price": 1049,
    "compareAt": 1249
   },
   "Queen": {
    "price": 1199,
    "compareAt": 1399
   },
   "King": {
    "price": 1899,
    "compareAt": 2099
   },
   "California King": {
    "price": 1899,
    "compareAt": 2099
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-plush-hybrid-mattress-by-serta-292874.jpg?v=1747357694",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-plush-hybrid-mattress-by-serta-292874.jpg?v=1747357694",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-plush-hybrid-mattress-by-serta-456671.jpg?v=1747357694",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-plush-hybrid-mattress-by-serta-184990.jpg?v=1747357694",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-coral-shores-quilted-plush-hybrid-mattress-by-serta-518334.jpg?v=1747357694"
  ],
  "description": "Soft, cool, and supportive-at an approachable price point. The Coral Shores Quilted Plush Hybrid is designed for sleepers who love a softer, cozier feel but still need dependable support. Premium memory foams cushion pressure points for deeper comfort, while a zoned support system of responsive…"
 },
 {
  "slug": "beautyrest-black-series-one-medium-mattress",
  "name": "Beautyrest Black Series One Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1749,
  "compareAt": 2049,
  "priceFrom": true,
  "sku": "BRB24-S1-TXLMM",
  "firmness": "Medium",
  "height": "14 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1749,
    "compareAt": 2049
   },
   "Full": {
    "price": 2029,
    "compareAt": 2329
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2499
   },
   "King": {
    "price": 2899,
    "compareAt": 3199
   },
   "California King": {
    "price": 2899,
    "compareAt": 3199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-mattress-by-simmons-732652.jpg?v=1724390963",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-mattress-by-simmons-732652.jpg?v=1724390963",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-mattress-by-simmons-2675308.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-mattress-by-simmons-8928740.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Your pathway to a rejuvenating night’s sleep begins here- the Beautyrest Black® Series One Medium Mattress blends the perfect balance of support and plushness. Ensuring you wake up feeling refreshed and revitalized each morning, Sleep Climate™ Technology keeps you cool and comfortable alongside…"
 },
 {
  "slug": "serta-perfect-sleeper-gulf-moon-quilted-medium-pillow-top-hybrid-mattress",
  "name": "Serta Perfect Sleeper Gulf Moon Quilted Medium Pillow Top Hybrid Mattress",
  "brand": "serta-perfect-sleeper",
  "category": "mattresses",
  "price": 1099,
  "compareAt": 1299,
  "priceFrom": true,
  "sku": "GULFMOON-TXLMPTM",
  "firmness": "Medium Pillow Top",
  "height": "14 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1099,
    "compareAt": 1299
   },
   "Full": {
    "price": 1249,
    "compareAt": 1449
   },
   "Queen": {
    "price": 1399,
    "compareAt": 1599
   },
   "King": {
    "price": 2099,
    "compareAt": 2299
   },
   "California King": {
    "price": 2099,
    "compareAt": 2299
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-gulf-moon-quilted-medium-pillow-top-hybrid-mattress-by-serta-812529.jpg?v=1747357692",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-gulf-moon-quilted-medium-pillow-top-hybrid-mattress-by-serta-812529.jpg?v=1747357692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-gulf-moon-quilted-medium-pillow-top-hybrid-mattress-by-serta-225389.jpg?v=1747357693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-gulf-moon-quilted-medium-pillow-top-hybrid-mattress-by-serta-707486.jpg?v=1747357693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-gulf-moon-quilted-medium-pillow-top-hybrid-mattress-by-serta-484875.jpg?v=1747357693"
  ],
  "description": "Night after night of extra-perfect sleep. Not too soft, not too firm-this one’s just right. The Serta Perfect Sleeper Quilted Medium Pillow Top Hybrid Mattress gives you comfy, all-over support with five targeted zones that help keep your body aligned while you sleep. The pillow top adds an extra…"
 },
 {
  "slug": "sealy-posturepedic-r-pro-spring-dupont-ii-medium-mattress",
  "name": "Sealy Posturepedic Pro Spring Dupont II Medium Mattress",
  "brand": "sealy",
  "category": "mattresses",
  "price": 1400,
  "compareAt": 1600,
  "priceFrom": true,
  "sku": "DUPONT-TMM",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Full",
   "Queen",
   "King",
   "California King",
   "Twin XL"
  ],
  "variants": {
   "Twin": {
    "price": 1400,
    "compareAt": 1600
   },
   "Full": {
    "price": 1440,
    "compareAt": 1660
   },
   "Queen": {
    "price": 1500,
    "compareAt": 1700
   },
   "King": {
    "price": 1950,
    "compareAt": 2200
   },
   "California King": {
    "price": 1950,
    "compareAt": 2200
   },
   "Twin XL": {
    "price": 1440,
    "compareAt": 1620
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-medium-mattress-by-sealy-113742.jpg?v=1748132134",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-medium-mattress-by-sealy-113742.jpg?v=1748132134",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-medium-mattress-by-sealy-582422.jpg?v=1748132134",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-medium-mattress-by-sealy-537845.jpg?v=1748132135",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-medium-mattress-by-sealy-387909.jpg?v=1748132135"
  ],
  "description": "Expertly Built. Thoroughly Tested. Incredibly Comfortable. Striking the perfect balance of comfy softness and support, this Sealy Posturepedic® Pro Medium Innerspring Mattress gives you support where your back needs it most and just the right amount of cushioning from gel foam layers. It stays…"
 },
 {
  "slug": "sealy-posturepedic-r-pro-spring-dupont-ii-firm-mattress",
  "name": "Sealy Posturepedic Pro Spring Dupont II Firm Mattress",
  "brand": "sealy",
  "category": "mattresses",
  "price": 1400,
  "compareAt": 1600,
  "priceFrom": true,
  "sku": "DUPONT-TFM",
  "firmness": "Firm",
  "height": "14\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 1400,
    "compareAt": 1600
   },
   "Twin XL": {
    "price": 1440,
    "compareAt": 1620
   },
   "Full": {
    "price": 1440,
    "compareAt": 1660
   },
   "Queen": {
    "price": 1500,
    "compareAt": 1700
   },
   "King": {
    "price": 1950,
    "compareAt": 2200
   },
   "California King": {
    "price": 1950,
    "compareAt": 2200
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-firm-mattress-by-sealy-451528.jpg?v=1747357690",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-firm-mattress-by-sealy-451528.jpg?v=1747357690",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-firm-mattress-by-sealy-784565.jpg?v=1747357691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-firm-mattress-by-sealy-827837.jpg?v=1747357691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-posturepedic-pro-spring-dupont-ii-firm-mattress-by-sealy-408983.jpg?v=1747357691"
  ],
  "description": "Expertly Built. Thoroughly Tested. Incredibly Comfortable. Smartly supportive, this Sealy Posturepedic® Pro Firm Innerspring Mattress helps you wake up ache-free. It’s made to keep your back aligned and ease pressure points, with layers of gel foam, encased coils, and super-targeted support right…"
 },
 {
  "slug": "beautyrest-black-series-three-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series Three Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 3849,
  "priceFrom": true,
  "sku": "BRB24-S3-TXLPPTM",
  "firmness": "Plush Pillow Top",
  "height": "16 3/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 3849
   },
   "Full": {
    "price": 3529,
    "compareAt": 4129
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4399
   },
   "King": {
    "price": 4599,
    "compareAt": 5199
   },
   "California King": {
    "price": 4599,
    "compareAt": 5199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-plush-pillow-top-mattress-by-simmons-515474.jpg?v=1713928245",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-plush-pillow-top-mattress-by-simmons-515474.jpg?v=1713928245",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-plush-pillow-top-mattress-by-simmons-6311401.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-plush-pillow-top-mattress-by-simmons-5149196.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-6093517.jpg?v=1774785012"
  ],
  "description": "The ultimate choice for a blissful slumber, the Beautyrest Black® Series Three Plush Pillow Top Mattress allows you to wake up on cloud-like comfort and deep-down support. Cooling and conforming with Sleep Climate™ Technology, two layers of SurfaceTouch™ Gel Memory Foam, and GelTouch® Foam, you'll…"
 },
 {
  "slug": "beautyrest-black-series-two-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series Two Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2649,
  "compareAt": 2949,
  "priceFrom": true,
  "sku": "BRB24-S2-TXLPPTM",
  "firmness": "Plush Pillow Top",
  "height": "16 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2649,
    "compareAt": 2949
   },
   "Full": {
    "price": 2929,
    "compareAt": 3229
   },
   "Queen": {
    "price": 3099,
    "compareAt": 3399
   },
   "King": {
    "price": 3799,
    "compareAt": 4099
   },
   "California King": {
    "price": 3799,
    "compareAt": 4099
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-pillow-top-mattress-by-simmons-200388.jpg?v=1713928245",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-pillow-top-mattress-by-simmons-200388.jpg?v=1713928245",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-pillow-top-mattress-by-simmons-914164.jpg?v=1713928245",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-pillow-top-mattress-by-simmons-357877.jpg?v=1713928245",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-pillow-top-mattress-by-simmons-330414.jpg?v=1713928245"
  ],
  "description": "Redefine your sleep experience with the indulgent feel of the Beautyrest Black® Series Two Plush Pillow Top Mattress, which gently cradles your body for a heavenly night’s rest. Beneath the refreshing heat dissipation of Sleep Climate™ Technology, two separate SurfaceTouch™ Gel Memory Foam layers,…"
 },
 {
  "slug": "beautyrest-black-series-three-firm-pillow-top-mattress",
  "name": "Beautyrest Black Series Three Firm Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3249,
  "compareAt": 3849,
  "priceFrom": true,
  "sku": "BRB24-S3-TXLFPTM",
  "firmness": "Firm Pillow Top",
  "height": "16 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3249,
    "compareAt": 3849
   },
   "Full": {
    "price": 3529,
    "compareAt": 4129
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4399
   },
   "King": {
    "price": 4599,
    "compareAt": 5199
   },
   "California King": {
    "price": 4599,
    "compareAt": 5199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-992723.jpg?v=1724390965",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-992723.jpg?v=1724390965",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-2694749.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-8459728.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-firm-pillow-top-mattress-by-simmons-1463885.jpg?v=1774785011"
  ],
  "description": "The pinnacle of comfort and support, the Beautyrest Black® Series Three Firm Pillow Top Mattress makes every night a luxurious experience. From the cooling, heat dissipating properties of Sleep Climate™ Technology to two layers of SurfaceTouch™ Gel Memory Foam and AirCool® HD Foam for instant…"
 },
 {
  "slug": "beautyrest-black-series-two-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series Two Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2649,
  "compareAt": 2949,
  "priceFrom": true,
  "sku": "BRB24-S2-TXLMPTM",
  "firmness": "Medium Pillow Top",
  "height": "16 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2649,
    "compareAt": 2949
   },
   "Full": {
    "price": 2929,
    "compareAt": 3229
   },
   "Queen": {
    "price": 3099,
    "compareAt": 3399
   },
   "King": {
    "price": 3799,
    "compareAt": 4099
   },
   "California King": {
    "price": 3799,
    "compareAt": 4099
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-pillow-top-mattress-by-simmons-834426.jpg?v=1724390966",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-pillow-top-mattress-by-simmons-834426.jpg?v=1724390966",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-pillow-top-mattress-by-simmons-406487.jpg?v=1763154376",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-pillow-top-mattress-by-simmons-871629.jpg?v=1763154376",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-medium-pillow-top-mattress-by-simmons-821923.jpg?v=1763154376"
  ],
  "description": "Cushioning and cozy with plenty of support, the Beautyrest Black® Series Two Medium Pillow Top Mattress helps you to experience a blissful night's sleep. Cradling your body with an extra layer of softness, refreshing Smart Climate™ Technology continuously dissipates heat alongside two separate…"
 },
 {
  "slug": "beautyrest-black-series-two-plush-mattress",
  "name": "Beautyrest Black Series Two Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2449,
  "compareAt": 2749,
  "priceFrom": true,
  "sku": "BRB24-S2-TXLPLM",
  "firmness": "Plush",
  "height": "15 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2449,
    "compareAt": 2749
   },
   "Full": {
    "price": 2729,
    "compareAt": 3029
   },
   "Queen": {
    "price": 2899,
    "compareAt": 3199
   },
   "King": {
    "price": 3599,
    "compareAt": 3899
   },
   "California King": {
    "price": 3599,
    "compareAt": 3899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-mattress-by-simmons-872214.jpg?v=1713928246",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-mattress-by-simmons-872214.jpg?v=1713928246",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-mattress-by-simmons-579965.jpg?v=1713928246",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-mattress-by-simmons-984276.jpg?v=1713928246",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-two-plush-mattress-by-simmons-919126.jpg?v=1713928246"
  ],
  "description": "Promising unparalleled comfort and support night after night, the Beautyrest Black® Series Two Plush Mattress allows you to indulge in cushioning with a soft, tight-top design. Whether curling up with a good book or drifting off to dreamland, Smart Climate™ Technology refreshes and dissipates heat,…"
 },
 {
  "slug": "beautyrest-black-series-one-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series One Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2049,
  "compareAt": 2349,
  "priceFrom": true,
  "sku": "BRB24-S1-TXLPPTM",
  "firmness": "Plush Pillow Top",
  "height": "14 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2049,
    "compareAt": 2349
   },
   "Full": {
    "price": 2329,
    "compareAt": 2629
   },
   "Queen": {
    "price": 2499,
    "compareAt": 2799
   },
   "King": {
    "price": 3199,
    "compareAt": 3499
   },
   "California King": {
    "price": 3199,
    "compareAt": 3499
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-pillow-top-mattress-by-simmons-278338.jpg?v=1724390964",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-pillow-top-mattress-by-simmons-278338.jpg?v=1724390964",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-pillow-top-mattress-by-simmons-7961004.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-pillow-top-mattress-by-simmons-8815128.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Welcome indulgent sleep comfort with the Beautyrest Black® Series One Plush Pillow Top Mattress that combines premium materials and proprietary engineering for rejuvenating rest. Merging Sleep Climate™ Technology for cooling, heat dissipating properties with 2 inches of upholstery for a true pillow…"
 },
 {
  "slug": "beautyrest-black-series-three-extra-firm-mattress",
  "name": "Beautyrest Black Series Three Extra Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3449,
  "priceFrom": true,
  "sku": "BRB24-S3-TXLXFM",
  "firmness": "Extra Firm",
  "height": "14 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3449
   },
   "Full": {
    "price": 3129,
    "compareAt": 3729
   },
   "Queen": {
    "price": 3399,
    "compareAt": 3999
   },
   "King": {
    "price": 4199,
    "compareAt": 4799
   },
   "California King": {
    "price": 4199,
    "compareAt": 4799
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-extra-firm-mattress-by-simmons-189417.jpg?v=1774636333",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-extra-firm-mattress-by-simmons-189417.jpg?v=1774636333",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-extra-firm-mattress-by-simmons-6456412.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-extra-firm-mattress-by-simmons-4912090.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Restorative sleep awaits with the Beautyrest Black® Series Three Extra Firm Mattress, built to last with a robust innerspring system and firmer comfort layers. Including Sleep Climate™ Technology for cooling heat dissipation near the cover, SurfaceTouch™ Gel Memory Foam and GentleSupport™ Foam…"
 },
 {
  "slug": "beautyrest-black-series-one-firm-pillow-top-mattress",
  "name": "Beautyrest Black Series One Firm Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2049,
  "compareAt": 2349,
  "priceFrom": true,
  "sku": "BRB24-S1-TXLFPTM",
  "firmness": "Firm Pillow Top",
  "height": "14 1/4\"",
  "type": "Memory Foam",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2049,
    "compareAt": 2349
   },
   "Full": {
    "price": 2329,
    "compareAt": 2629
   },
   "Queen": {
    "price": 2499,
    "compareAt": 2799
   },
   "King": {
    "price": 3199,
    "compareAt": 3499
   },
   "California King": {
    "price": 3199,
    "compareAt": 3499
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-firm-pillow-top-mattress-by-simmons-342078.jpg?v=1724390963",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-firm-pillow-top-mattress-by-simmons-342078.jpg?v=1724390963",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-firm-pillow-top-mattress-by-simmons-1748314.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-firm-pillow-top-mattress-by-simmons-4838130.jpg?v=1774785011",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Sink into a realm of supportive serenity with the Beautyrest Black® Series One Firm Pillow Top Mattress, meticulously engineered to cradle the body and provide optimal support simultaneously. Including Smart Climate™ Technology to dissipate body heat, open-cell AirFeel® Foam and GentleSupport™ Foam…"
 },
 {
  "slug": "beautyrest-black-series-four-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series Four Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4249,
  "compareAt": 4949,
  "priceFrom": true,
  "sku": "BRB24-S4-TXLMPTM",
  "firmness": "Medium Pillow Top",
  "height": "17 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4249,
    "compareAt": 4949
   },
   "Full": {
    "price": 4529,
    "compareAt": 5229
   },
   "Queen": {
    "price": 4899,
    "compareAt": 5599
   },
   "King": {
    "price": 5899,
    "compareAt": 6599
   },
   "California King": {
    "price": 5899,
    "compareAt": 6599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-medium-pillow-top-mattress-by-simmons-606786.jpg?v=1713928224",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-medium-pillow-top-mattress-by-simmons-606786.jpg?v=1713928224",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-medium-pillow-top-mattress-by-simmons-109264.jpg?v=1713928224",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-medium-pillow-top-mattress-by-simmons-504761.jpg?v=1713928224",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-medium-pillow-top-mattress-by-simmons-750647.jpg?v=1713928224"
  ],
  "description": "Say goodbye to tossing and turning as you sink into blissful comfort every night with the Beautyrest Black® Series Four Medium Pillow Top Mattress, flaunting cooling Sleep Climate™ Technology. Including two separate SurfaceTouch™ Gel Memory Foam layers and AirCool® HD Foam, get cozy with premium…"
 },
 {
  "slug": "beautyrest-black-series-one-plush-mattress",
  "name": "Beautyrest Black Series One Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 1749,
  "compareAt": 2049,
  "priceFrom": true,
  "sku": "BRB24-S1-TXLPLM",
  "firmness": "Plush",
  "height": "14\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1749,
    "compareAt": 2049
   },
   "Full": {
    "price": 2029,
    "compareAt": 2329
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2499
   },
   "King": {
    "price": 2899,
    "compareAt": 3199
   },
   "California King": {
    "price": 2899,
    "compareAt": 3199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-mattress-by-simmons-460311.jpg?v=1774640098",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-mattress-by-simmons-460311.jpg?v=1774640098",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-mattress-by-simmons-4344528.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-plush-mattress-by-simmons-6426727.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Meticulously engineered to cradle your body in sublime comfort, the Beautyrest Black® Series One Plush Mattress allows you to sink into a world of relaxation. Ensuring a rejuvenating sleep every night, body heat dissipating Sleep Climate™ Technology promotes a cool, cozy environment above…"
 },
 {
  "slug": "beautyrest-black-series-four-plush-pillow-top-mattress",
  "name": "Beautyrest Black Series Four Plush Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4249,
  "compareAt": 4949,
  "priceFrom": true,
  "sku": "BRB24-S4-TXLPPTM",
  "firmness": "Plush Pillow Top",
  "height": "17 1/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4249,
    "compareAt": 4949
   },
   "Full": {
    "price": 4529,
    "compareAt": 5229
   },
   "Queen": {
    "price": 4899,
    "compareAt": 5599
   },
   "King": {
    "price": 5899,
    "compareAt": 6599
   },
   "California King": {
    "price": 5899,
    "compareAt": 6599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-plush-pillow-top-mattress-by-simmons-458361.jpg?v=1713928222",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-plush-pillow-top-mattress-by-simmons-458361.jpg?v=1713928222",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-plush-pillow-top-mattress-by-simmons-336381.jpg?v=1713928223",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-plush-pillow-top-mattress-by-simmons-281045.jpg?v=1713928223",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-plush-pillow-top-mattress-by-simmons-111968.jpg?v=1713928222"
  ],
  "description": "Drift off into a serene slumber with the top-of-the-line cushioning of the Beautyrest Black® Series Four Plush Pillow Top Mattress, made with heat-dissipating Sleep Climate™ Technology. An indulgent experience, two separate SurfaceTouch™ Gel Memory Foam layers and GelTouch® Foam instantly greet you…"
 },
 {
  "slug": "beautyrest-black-series-one-medium-pillow-top-mattress",
  "name": "Beautyrest Black Series One Medium Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2049,
  "compareAt": 2349,
  "priceFrom": true,
  "sku": "BRB24-S1-TXLMPTM",
  "firmness": "Medium Pillow Top",
  "height": "14 3/4\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2049,
    "compareAt": 2349
   },
   "Full": {
    "price": 2329,
    "compareAt": 2629
   },
   "Queen": {
    "price": 2499,
    "compareAt": 2799
   },
   "King": {
    "price": 3199,
    "compareAt": 3499
   },
   "California King": {
    "price": 3199,
    "compareAt": 3499
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-pillow-top-mattress-by-simmons-769687.jpg?v=1724390963",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-pillow-top-mattress-by-simmons-769687.jpg?v=1724390963",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-pillow-top-mattress-by-simmons-4966867.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-one-medium-pillow-top-mattress-by-simmons-8807209.jpg?v=1774785010",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-three-medium-mattress-by-simmons-7347700.jpg?v=1774640317"
  ],
  "description": "Cradling your body for a restful slumber, the Beautyrest Black® Series One Medium Pillow Top Mattress strikes the perfect balance of comfort and support for a rejuvenating night’s sleep. Crafted with premium materials and expert engineering, Sleep Climate™ Technology keeps you cool and cozy by…"
 },
 {
  "slug": "beautyrest-black-series-four-firm-pillow-top-mattress",
  "name": "Beautyrest Black Series Four Firm Pillow Top Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4249,
  "compareAt": 4949,
  "priceFrom": true,
  "sku": "BRB24-S4-TXLFPTM",
  "firmness": "Firm Pillow Top",
  "height": "17 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4249,
    "compareAt": 4949
   },
   "Full": {
    "price": 4529,
    "compareAt": 5229
   },
   "Queen": {
    "price": 4899,
    "compareAt": 5599
   },
   "King": {
    "price": 5899,
    "compareAt": 6599
   },
   "California King": {
    "price": 5899,
    "compareAt": 6599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-firm-pillow-top-mattress-by-simmons-826522.jpg?v=1724390963",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-firm-pillow-top-mattress-by-simmons-826522.jpg?v=1724390963",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-firm-pillow-top-mattress-by-simmons-481479.jpg?v=1724694212",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-firm-pillow-top-mattress-by-simmons-688134.jpg?v=1724694212",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-series-four-firm-pillow-top-mattress-by-simmons-418774.jpg?v=1724694212"
  ],
  "description": "Make every night a luxury experience with the high-end design of the Beautyrest Black® Series Four Firm Pillow Top Mattress, featuring heat-dissipating Sleep Climate™ Technology. Combining two layers of SurfaceTouch™ Gel Memory Foam with AirCool® HD Foam, you'll instantly feel the advanced pressure…"
 },
 {
  "slug": "serta-iseries-nxg-4500-hybrid-plush-mattress",
  "name": "Serta iSeries NXG 4500 Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2499,
  "compareAt": 2899,
  "priceFrom": true,
  "sku": "ISER4500HY-TXLPLM",
  "firmness": "Plush",
  "height": "13 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2499,
    "compareAt": 2899
   },
   "Full": {
    "price": 2649,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3199
   },
   "Split-Head Queen": {
    "price": 3399,
    "compareAt": 3799
   },
   "King": {
    "price": 3499,
    "compareAt": 3899
   },
   "Split-Head King": {
    "price": 4099,
    "compareAt": 4499
   },
   "California King": {
    "price": 3499,
    "compareAt": 3899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-hybrid-plush-mattress-by-serta-8863282.jpg?v=1767148692",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-hybrid-plush-mattress-by-serta-8863282.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-hybrid-plush-mattress-by-serta-8895342.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-hybrid-plush-mattress-by-serta-3145302.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-hybrid-plush-mattress-by-serta-5671469.jpg?v=1767148693"
  ],
  "description": "Plush comfort. Responsive support. Cooling relief. The Serta iSeries NXG 4500 Hybrid Plush mattress offers a softer, more cushioning sleep experience with the added responsiveness of a hybrid design. Built with a series of benefits for the sleep you want, it delivers immediate cooling,…"
 },
 {
  "slug": "serta-iseries-nxg-4500-all-foam-ultra-plush-mattress",
  "name": "Serta iSeries NXG 4500 All-Foam Ultra Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2499,
  "compareAt": 2899,
  "priceFrom": true,
  "sku": "ISER4500-TXLPLM",
  "firmness": "Ultra Plush",
  "height": "13 1/2\"",
  "type": "Memory Foam",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2499,
    "compareAt": 2899
   },
   "Full": {
    "price": 2649,
    "compareAt": 3049
   },
   "Queen": {
    "price": 2799,
    "compareAt": 3199
   },
   "Split-Head Queen": {
    "price": 3399,
    "compareAt": 3799
   },
   "King": {
    "price": 3499,
    "compareAt": 3899
   },
   "Split-Head King": {
    "price": 4099,
    "compareAt": 4499
   },
   "California King": {
    "price": 3499,
    "compareAt": 3899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-all-foam-ultra-plush-mattress-by-serta-6917897.jpg?v=1767148692",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-all-foam-ultra-plush-mattress-by-serta-6917897.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-all-foam-ultra-plush-mattress-by-serta-7965127.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-all-foam-ultra-plush-mattress-by-serta-5602697.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-4500-all-foam-ultra-plush-mattress-by-serta-3093172.jpg?v=1767148693"
  ],
  "description": "Ultra-plush comfort. Deep pressure relief. Elevated cooling. The Serta iSeries NXG 4500 All-Foam Ultra Plush mattress is designed for sleepers who want maximum softness and pressure relief without sacrificing supportive stability. Its ultra plush feel allows the body to gently sink in, cradling the…"
 },
 {
  "slug": "https-1nn0c1dr7wrld4wu-24209425-shopifypreview-com-products_preview-variant-62405331943795",
  "name": "Serta iSeries NXG 2500 All-Foam Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2199,
  "priceFrom": true,
  "sku": "ISER2500-TXLPLM",
  "firmness": "Plush",
  "height": "12 1/2\"",
  "type": "Memory Foam",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1899,
    "compareAt": 2199
   },
   "Full": {
    "price": 2049,
    "compareAt": 2349
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2499
   },
   "King": {
    "price": 2899,
    "compareAt": 3199
   },
   "California King": {
    "price": 2899,
    "compareAt": 3199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-all-foam-plush-mattress-by-serta-7510392.jpg?v=1767148690",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-all-foam-plush-mattress-by-serta-7510392.jpg?v=1767148690",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-all-foam-plush-mattress-by-serta-4071349.jpg?v=1767148690",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-all-foam-plush-mattress-by-serta-9997499.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-all-foam-plush-mattress-by-serta-4158890.jpg?v=1767148691"
  ],
  "description": "Plush comfort. Cooling performance. Gentle contouring. The Serta iSeries NXG 2500 All-Foam Plush mattress is designed for sleepers who crave a softer, more enveloping feel without compromising proper support. Its plush comfort layers allow the body to gently sink in, relieving pressure at the…"
 },
 {
  "slug": "serta-iseries-nxg-3500-hybrid-medium-mattress",
  "name": "Serta iSeries NXG 3500 Hybrid Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2299,
  "compareAt": 2599,
  "priceFrom": true,
  "sku": "ISER3500HY-TXLMM",
  "firmness": "Medium",
  "height": "13 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2299,
    "compareAt": 2599
   },
   "Full": {
    "price": 2449,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2599,
    "compareAt": 2899
   },
   "Split-Head Queen": {
    "price": 3199,
    "compareAt": 3499
   },
   "King": {
    "price": 3299,
    "compareAt": 3599
   },
   "Split-Head King": {
    "price": 3899,
    "compareAt": 4199
   },
   "California King": {
    "price": 3299,
    "compareAt": 3599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-medium-mattress-by-serta-7270772.jpg?v=1767148692",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-medium-mattress-by-serta-7270772.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-medium-mattress-by-serta-1458511.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-medium-mattress-by-serta-9200934.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-medium-mattress-by-serta-2925200.jpg?v=1767148693"
  ],
  "description": "Balanced comfort. Adaptive support. Advanced cooling. The Serta iSeries NXG 3500 Hybrid Medium mattress is thoughtfully designed for sleepers who change positions throughout the night and couples with different comfort preferences. Built with a series of benefits for the sleep you want, it delivers…"
 },
 {
  "slug": "serta-iseries-nxg-2500-hybrid-plush-mattress",
  "name": "Serta iSeries NXG 2500 Hybrid Plush Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1899,
  "compareAt": 2199,
  "priceFrom": true,
  "sku": "ISER2500HY-TXLPLM",
  "firmness": "Plush",
  "height": "12 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1899,
    "compareAt": 2199
   },
   "Full": {
    "price": 2049,
    "compareAt": 2349
   },
   "Queen": {
    "price": 2199,
    "compareAt": 2499
   },
   "King": {
    "price": 2899,
    "compareAt": 3199
   },
   "California King": {
    "price": 2899,
    "compareAt": 3199
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-plush-mattress-by-serta-2898161.jpg?v=1767148691",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-plush-mattress-by-serta-2898161.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-plush-mattress-by-serta-7592926.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-plush-mattress-by-serta-7847051.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-2500-hybrid-plush-mattress-by-serta-6453669.jpg?v=1767148692"
  ],
  "description": "Plush comfort. Responsive support. Cooling performance. The Serta iSeries NXG 2500 Hybrid Plush mattress is designed for sleepers who enjoy a softer, more cushioning feel paired with the responsive support of a hybrid design. Built with a series of benefits for the sleep you want, it delivers…"
 },
 {
  "slug": "serta-iseries-nxg-3500-hybrid-firm-mattress",
  "name": "Serta iSeries NXG 3500 Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2299,
  "compareAt": 2599,
  "priceFrom": true,
  "sku": "ISER3500HY-TXLFM",
  "firmness": "Firm",
  "height": "13 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2299,
    "compareAt": 2599
   },
   "Full": {
    "price": 2449,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2599,
    "compareAt": 2899
   },
   "Split-Head Queen": {
    "price": 3199,
    "compareAt": 3499
   },
   "King": {
    "price": 3299,
    "compareAt": 3599
   },
   "Split-Head King": {
    "price": 3899,
    "compareAt": 4199
   },
   "California King": {
    "price": 3299,
    "compareAt": 3599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-firm-mattress-by-serta-9666007.jpg?v=1767148692",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-firm-mattress-by-serta-9666007.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-firm-mattress-by-serta-4983457.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-firm-mattress-by-serta-3519690.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-hybrid-firm-mattress-by-serta-9949899.jpg?v=1767148693"
  ],
  "description": "Firm feel. Zoned support. Advanced cooling. The Serta iSeries NXG 3500 Hybrid Firm mattress delivers a more robust, supportive sleep experience with enhanced height and advanced hybrid performance. Designed with a series of benefits for the sleep you want, it provides immediate cooling, deep…"
 },
 {
  "slug": "serta-iseries-nxg-1500-hybrid-firm-mattress",
  "name": "Serta iSeries NXG 1500 Hybrid Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 1899,
  "priceFrom": true,
  "sku": "ISER1500HY-TXLFM",
  "firmness": "Firm",
  "height": "12\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1599,
    "compareAt": 1899
   },
   "Full": {
    "price": 1749,
    "compareAt": 2049
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2199
   },
   "King": {
    "price": 2599,
    "compareAt": 2899
   },
   "California King": {
    "price": 2599,
    "compareAt": 2899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-hybrid-firm-mattress-by-serta-7760494.jpg?v=1767148692",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-hybrid-firm-mattress-by-serta-7760494.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-hybrid-firm-mattress-by-serta-3705299.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-hybrid-firm-mattress-by-serta-9726450.jpg?v=1767148692",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-hybrid-firm-mattress-by-serta-9057611.jpg?v=1767148692"
  ],
  "description": "Firm comfort. Cooling relief. Targeted support. The Serta iSeries NXG 1500 Hybrid Firm mattress is designed for sleepers who prefer a firmer, more supportive feel with the added responsiveness of a hybrid design. Built with a series of benefits for the sleep you want, it delivers immediate cooling,…"
 },
 {
  "slug": "serta-iseries-nxg-3500-all-foam-medium-mattress",
  "name": "Serta iSeries NXG 3500 All-Foam Medium Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 2299,
  "compareAt": 2599,
  "priceFrom": true,
  "sku": "ISER3500-TXLMM",
  "firmness": "Medium",
  "height": "13 1/2\"",
  "type": "Memory Foam",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2299,
    "compareAt": 2599
   },
   "Full": {
    "price": 2449,
    "compareAt": 2749
   },
   "Queen": {
    "price": 2599,
    "compareAt": 2899
   },
   "Split-Head Queen": {
    "price": 3199,
    "compareAt": 3499
   },
   "King": {
    "price": 3299,
    "compareAt": 3599
   },
   "Split-Head King": {
    "price": 3899,
    "compareAt": 4199
   },
   "California King": {
    "price": 3299,
    "compareAt": 3599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-all-foam-medium-mattress-by-serta-6967716.jpg?v=1767148693",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-all-foam-medium-mattress-by-serta-6967716.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-all-foam-medium-mattress-by-serta-4119406.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-all-foam-medium-mattress-by-serta-4592320.jpg?v=1767148693",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-3500-all-foam-medium-mattress-by-serta-9244083.jpg?v=1767148693"
  ],
  "description": "Balanced comfort. Adaptive support. Advanced cooling. The Serta iSeries NXG 3500 All-Foam Medium mattress is thoughtfully designed for sleepers who change positions throughout the night and for couples with different comfort needs. Its medium feel delivers the ideal balance of cushioning and…"
 },
 {
  "slug": "serta-iseries-nxg-1500-all-foam-luxury-firm-mattress",
  "name": "Serta iSeries NXG 1500 All-Foam Luxury Firm Mattress",
  "brand": "serta",
  "category": "mattresses",
  "price": 1599,
  "compareAt": 1899,
  "priceFrom": true,
  "sku": "ISER1500-TXLLXFM",
  "firmness": "Firm",
  "height": "12\"",
  "type": "Memory Foam",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 1599,
    "compareAt": 1899
   },
   "Full": {
    "price": 1749,
    "compareAt": 2049
   },
   "Queen": {
    "price": 1899,
    "compareAt": 2199
   },
   "King": {
    "price": 2599,
    "compareAt": 2899
   },
   "California King": {
    "price": 2599,
    "compareAt": 2899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-all-foam-luxury-firm-mattress-by-serta-4729131.jpg?v=1767148691",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-all-foam-luxury-firm-mattress-by-serta-4729131.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-all-foam-luxury-firm-mattress-by-serta-9805716.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-all-foam-luxury-firm-mattress-by-serta-4952435.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-iseries-nxg-1500-all-foam-luxury-firm-mattress-by-serta-5166483.jpg?v=1767148691"
  ],
  "description": "Firm comfort. Cooling relief. Reliable support. The Serta iSeries NXG 1500 All-Foam Luxury Firm mattress is designed for sleepers who prefer a supportive, stable sleep surface with minimal sink. Its luxury firm feel helps keep the body properly aligned by preventing the hips and midsection from…"
 },
 {
  "slug": "beautyrest-core-level-2-extra-firm-innerspring-mattress",
  "name": "Beautyrest Core Level 2 Extra Firm Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 850,
  "compareAt": 1250,
  "priceFrom": true,
  "sku": "BR25-L2-TXFM",
  "firmness": "Extra Firm",
  "height": "14 3/4\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 850,
    "compareAt": 1250
   },
   "Twin XL": {
    "price": 880,
    "compareAt": 1290
   },
   "Full": {
    "price": 880,
    "compareAt": 1360
   },
   "Queen": {
    "price": 900,
    "compareAt": 1390
   },
   "King": {
    "price": 1300,
    "compareAt": 1940
   },
   "California King": {
    "price": 1300,
    "compareAt": 1940
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-extra-firm-innerspring-mattress-by-simmons-3645968.jpg?v=1774508294",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-extra-firm-innerspring-mattress-by-simmons-3645968.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-extra-firm-innerspring-mattress-by-simmons-4938030.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-extra-firm-innerspring-mattress-by-simmons-8232944.jpg?v=1774508295",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-extra-firm-innerspring-mattress-by-simmons-8271611.jpg?v=1774508294"
  ],
  "description": "Strong support. Stable alignment. Firm comfort that holds you steady. The Beautyrest® Core Level Two Extra Firm Mattress delivers a strong, supportive feel that keeps your body aligned from head to toe. Its firm surface minimizes pressure buildup and helps maintain even support across the body.…"
 },
 {
  "slug": "beautyrest-r-core-level-2-medium-innerspring-mattress",
  "name": "Beautyrest Core Level 2 Medium Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 850,
  "compareAt": 1250,
  "priceFrom": true,
  "sku": "BR25-L2-TMM",
  "firmness": "Medium",
  "height": "14 3/4\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 850,
    "compareAt": 1250
   },
   "Twin XL": {
    "price": 880,
    "compareAt": 1290
   },
   "Full": {
    "price": 880,
    "compareAt": 1360
   },
   "Queen": {
    "price": 900,
    "compareAt": 1390
   },
   "King": {
    "price": 1300,
    "compareAt": 1940
   },
   "California King": {
    "price": 1300,
    "compareAt": 1940
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-innerspring-mattress-by-simmons-2069271.jpg?v=1774508293",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-innerspring-mattress-by-simmons-2069271.jpg?v=1774508293",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-innerspring-mattress-by-simmons-6642990.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-innerspring-mattress-by-simmons-7688025.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-innerspring-mattress-by-simmons-2177061.jpg?v=1774508295"
  ],
  "description": "Balanced comfort. Adaptive support. Rest that feels just right. The Beautyrest® Core Level Two Medium Mattress delivers a balanced feel that supports your body while gently easing pressure throughout the night. Its surface adapts to your natural contours, and a breathable sleep surface helps…"
 },
 {
  "slug": "beautyrest-core-level-two-medium-firm-pillow-top-innerspring-mattress",
  "name": "Beautyrest Core Level 2 Medium Firm Pillow Top Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 900,
  "compareAt": 1380,
  "priceFrom": true,
  "sku": "BR25-L2-TMPTM",
  "firmness": "Med-Firm Pillow Top",
  "height": "16\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 950,
    "compareAt": 1380
   },
   "Twin XL": {
    "price": 980,
    "compareAt": 1400
   },
   "Full": {
    "price": 980,
    "compareAt": 1480
   },
   "Queen": {
    "price": 900,
    "compareAt": 1500
   },
   "King": {
    "price": 1400,
    "compareAt": 2060
   },
   "California King": {
    "price": 1400,
    "compareAt": 2060
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-firm-pillow-top-innerspring-mattress-by-simmons-3115216.jpg?v=1774508294",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-firm-pillow-top-innerspring-mattress-by-simmons-3115216.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-firm-pillow-top-innerspring-mattress-by-simmons-8571797.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-firm-pillow-top-innerspring-mattress-by-simmons-5513725.jpg?v=1774508295",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-medium-firm-pillow-top-innerspring-mattress-by-simmons-9435722.jpg?v=1774508295"
  ],
  "description": "Cushioned comfort. Structured support. The perfect balance with a softer touch. The Beautyrest® Core Level Two Medium Firm Pillow Top Mattress blends balanced support with added cushioning for comfort that’s both stable and inviting. Its pillow top layer softens the initial feel while underlying…"
 },
 {
  "slug": "beautyrest-core-level-two-plush-innerspring-mattress",
  "name": "Beautyrest Core Level 2 Plush Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 850,
  "compareAt": 1250,
  "priceFrom": true,
  "sku": "BR25-L2-TPLM",
  "firmness": "Plush",
  "height": "14\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 850,
    "compareAt": 1250
   },
   "Twin XL": {
    "price": 880,
    "compareAt": 1290
   },
   "Full": {
    "price": 880,
    "compareAt": 1360
   },
   "Queen": {
    "price": 900,
    "compareAt": 1390
   },
   "King": {
    "price": 1300,
    "compareAt": 1940
   },
   "California King": {
    "price": 1300,
    "compareAt": 1940
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-innerspring-mattress-by-simmons-3725776.jpg?v=1774508294",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-innerspring-mattress-by-simmons-3725776.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-innerspring-mattress-by-simmons-7081255.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-innerspring-mattress-by-simmons-3619259.jpg?v=1774508295",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-innerspring-mattress-by-simmons-4591861.jpg?v=1774508294"
  ],
  "description": "Gentle cushioning. Soothing comfort. Softness that still supports. The Beautyrest® Core Level Two Plush Mattress surrounds you in gentle cushioning while maintaining dependable support underneath. Its softer surface helps relieve pressure at the shoulders and hips, while the supportive core keeps…"
 },
 {
  "slug": "beautyrest-core-level-two-plush-pillow-top-innerspring-mattress",
  "name": "Beautyrest Core Level 2 Plush Pillow Top Innerspring Mattress",
  "brand": "beautyrest",
  "category": "mattresses",
  "price": 900,
  "compareAt": 1380,
  "priceFrom": true,
  "sku": "BR25-L2-TPPTM",
  "firmness": "Plush Pillow Top",
  "height": "14 3/4\"",
  "type": "Innerspring",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 950,
    "compareAt": 1380
   },
   "Twin XL": {
    "price": 980,
    "compareAt": 1400
   },
   "Full": {
    "price": 980,
    "compareAt": 1480
   },
   "Queen": {
    "price": 900,
    "compareAt": 1500
   },
   "King": {
    "price": 1400,
    "compareAt": 2060
   },
   "California King": {
    "price": 1400,
    "compareAt": 2060
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-pillow-top-innerspring-mattress-by-simmons-2969483.jpg?v=1774508293",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-pillow-top-innerspring-mattress-by-simmons-2969483.jpg?v=1774508293",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-pillow-top-innerspring-mattress-by-simmons-9926426.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-pillow-top-innerspring-mattress-by-simmons-4937560.jpg?v=1774508294",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-core-level-2-plush-pillow-top-innerspring-mattress-by-simmons-1732555.jpg?v=1774508294"
  ],
  "description": "Deep cushioning. Cloudlike comfort. Plush relief with dependable support. The Beautyrest® Core Level 2 Plush Pillow Top Mattress delivers a deeply cushioned sleep experience designed to cradle your body in softness while maintaining reliable support underneath. The added pillow top enhances…"
 },
 {
  "slug": "serta-perfect-sleeper-island-bliss-medium-mattress",
  "name": "Serta Perfect Sleeper Island Bliss Medium Mattress",
  "brand": "serta-perfect-sleeper",
  "category": "mattresses",
  "price": 800,
  "compareAt": 1350,
  "priceFrom": true,
  "sku": "ISLANDBLISS-TMM",
  "firmness": "Medium",
  "height": "12 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 800,
    "compareAt": 1350
   },
   "Twin XL": {
    "price": 900,
    "compareAt": 1500
   },
   "Full": {
    "price": 950,
    "compareAt": 1500
   },
   "Queen": {
    "price": 950,
    "compareAt": 1500
   },
   "King": {
    "price": 1300,
    "compareAt": 2050
   },
   "California King": {
    "price": 1300,
    "compareAt": 2050
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-mattress-by-serta-6434590.jpg?v=1776887478",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-mattress-by-serta-6434590.jpg?v=1776887478",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress-by-serta-4044564.jpg?v=1776887478",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-mattress-by-serta-1358267.jpg?v=1776887477",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-mattress-by-serta-3174826.jpg?v=1776887478"
  ],
  "description": "Balanced comfort. Responsive support. Cooler, consistent sleep. The Serta Perfect Sleeper Island Bliss Medium Mattress is designed to deliver that “just right” feel-comfortably cushioning the body while maintaining the support needed for proper alignment. It gently relieves pressure points without…"
 },
 {
  "slug": "serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress",
  "name": "Serta Perfect Sleeper Island Bliss Medium Pillow Top Mattress",
  "brand": "serta-perfect-sleeper",
  "category": "mattresses",
  "price": 900,
  "compareAt": 1400,
  "priceFrom": true,
  "sku": "ISLANDBLISS-TMPTM",
  "firmness": "Medium Pillow Top",
  "height": "12 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 900,
    "compareAt": 1400
   },
   "Twin XL": {
    "price": 950,
    "compareAt": 1550
   },
   "Full": {
    "price": 1000,
    "compareAt": 1550
   },
   "Queen": {
    "price": 1000,
    "compareAt": 1550
   },
   "King": {
    "price": 1400,
    "compareAt": 2100
   },
   "California King": {
    "price": 1400,
    "compareAt": 2100
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress-by-serta-4481449.jpg?v=1776887478",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress-by-serta-4481449.jpg?v=1776887478",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress-by-serta-4044564.jpg?v=1776887478",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress-by-serta-9199820.jpg?v=1776887478",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-medium-pillow-top-mattress-by-serta-3467701.jpg?v=1776887478"
  ],
  "description": "Plush comfort. Balanced support. Cooler, more restorative sleep. The Serta Perfect Sleeper Island Bliss Medium Pillow Top Mattress creates a deeply comfortable sleep experience with an elevated, cushioned feel that gently cradles the body without sacrificing support. The pillow top adds an extra…"
 },
 {
  "slug": "serta-perfect-sleeper-island-bliss-firm-mattress",
  "name": "Serta Perfect Sleeper Island Bliss Firm Mattress",
  "brand": "serta-perfect-sleeper",
  "category": "mattresses",
  "price": 750,
  "compareAt": 1300,
  "priceFrom": true,
  "sku": "ISLANDBLISS-TFM",
  "firmness": "Firm",
  "height": "12 1/2\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 750,
    "compareAt": 1300
   },
   "Twin XL": {
    "price": 850,
    "compareAt": 1400
   },
   "Full": {
    "price": 900,
    "compareAt": 1400
   },
   "Queen": {
    "price": 900,
    "compareAt": 1400
   },
   "King": {
    "price": 1250,
    "compareAt": 1950
   },
   "California King": {
    "price": 1250,
    "compareAt": 1950
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-firm-mattress-by-serta-8873795.jpg?v=1776887479",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-firm-mattress-by-serta-8873795.jpg?v=1776887479",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-firm-mattress-by-serta-6794715.jpg?v=1776887480",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-firm-mattress-by-serta-2237676.jpg?v=1776887480",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-perfect-sleeper-island-bliss-firm-mattress-by-serta-6500848.jpg?v=1776887480"
  ],
  "description": "Firm support. Targeted alignment. Stable, restorative sleep. The Serta Perfect Sleeper Island Bliss Firm Mattress is built for sleepers who prefer a more supportive, lifted feel with minimal give. Its firm comfort helps keep your body properly aligned, reducing pressure while maintaining a stable,…"
 },
 {
  "slug": "beautyrest-black-hybrid-series-three-xcs-plush-mattress",
  "name": "Beautyrest Black Hybrid Series Three XCS Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 2849,
  "compareAt": 3449,
  "priceFrom": true,
  "sku": "BRB26HY-S3-TXLPLM",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "Split Head Queen",
   "King",
   "Split Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 2849,
    "compareAt": 3449
   },
   "Queen": {
    "price": 3399,
    "compareAt": 3999
   },
   "Split Head Queen": {
    "price": 3999,
    "compareAt": 4599
   },
   "King": {
    "price": 4099,
    "compareAt": 4699
   },
   "Split Head King": {
    "price": 4699,
    "compareAt": 5299
   },
   "California King": {
    "price": 4099,
    "compareAt": 4699
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-plush-mattress-by-simmons-3195500.jpg?v=1781205732",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-plush-mattress-by-simmons-3195500.jpg?v=1781205732",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-plush-mattress-by-simmons-2415314.jpg?v=1781205731",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-plush-mattress-by-simmons-6354952.jpg?v=1781205732",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-three-xcs-plush-mattress-by-simmons-3325088.jpg?v=1781205733"
  ],
  "description": "Soft comfort. Deep pressure relief. Cool, cushioned sleep. The Beautyrest Black® Series Three XCS Plush Hybrid Mattress offers a softer, more cushioned feel with deeper contouring that gently cradles your body. It relieves pressure at key areas like the shoulders and hips while still maintaining…"
 },
 {
  "slug": "beautyrest-black-hybrid-series-four-xcs-firm-mattress",
  "name": "Beautyrest Black Hybrid Series Four XCS Firm Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3149,
  "compareAt": 3849,
  "priceFrom": true,
  "sku": "BRB26HY-S4-TXLFM",
  "firmness": "Firm",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "Split Head Queen",
   "King",
   "Split Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3149,
    "compareAt": 3849
   },
   "Queen": {
    "price": 3799,
    "compareAt": 4499
   },
   "Split Head Queen": {
    "price": 4399,
    "compareAt": 5099
   },
   "King": {
    "price": 4699,
    "compareAt": 5399
   },
   "Split Head King": {
    "price": 5299,
    "compareAt": 5999
   },
   "California King": {
    "price": 4699,
    "compareAt": 5399
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-firm-mattress-by-simmons-3015096.jpg?v=1781205734",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-firm-mattress-by-simmons-3015096.jpg?v=1781205734",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-firm-mattress-by-simmons-9148373.jpg?v=1781205734",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-firm-mattress-by-simmons-6262467.jpg?v=1781205735",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-firm-mattress-by-simmons-2556652.jpg?v=1781205735"
  ],
  "description": "Elevated support. Instant contouring. Advanced cooling comfort. The Beautyrest Black® Series Four XCS Firm Hybrid Mattress builds on the support of Series Three by adding a more responsive, instantly contouring feel. It delivers firm support while adapting more quickly to your body, creating a more…"
 },
 {
  "slug": "beautyrest-black-hybrid-series-four-xcs-medium-mattress",
  "name": "Beautyrest Black Hybrid Series Four XCS Medium Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 3649,
  "compareAt": 4349,
  "priceFrom": true,
  "sku": "BRB26HY-S4-TXLMM",
  "firmness": "Medium",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "Split Head Queen",
   "King",
   "Split Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3649,
    "compareAt": 4349
   },
   "Queen": {
    "price": 4299,
    "compareAt": 4999
   },
   "Split Head Queen": {
    "price": 4899,
    "compareAt": 5599
   },
   "King": {
    "price": 5199,
    "compareAt": 5899
   },
   "Split Head King": {
    "price": 5799,
    "compareAt": 6499
   },
   "California King": {
    "price": 5199,
    "compareAt": 5899
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-medium-mattress-by-simmons-2775220.jpg?v=1781582290",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-medium-mattress-by-simmons-2775220.jpg?v=1781582290",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-medium-mattress-by-simmons-1887080.jpg?v=1781582291",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-medium-mattress-by-simmons-1190264.jpg?v=1781582291",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-four-xcs-medium-mattress-by-simmons-2970911.jpg?v=1781582291"
  ],
  "description": "Deeper comfort. Adaptive support. Elevated hybrid performance. The Beautyrest Black® Series Four XCS Medium Hybrid Mattress elevates balanced comfort with deeper contouring and a more adaptive, responsive feel. Compared to Series Three, it conforms more quickly and more completely to your body,…"
 },
 {
  "slug": "beautyrest-black-hybrid-series-five-xcs-plush-mattress",
  "name": "Beautyrest Black Hybrid Series Five XCS Plush Mattress",
  "brand": "beautyrest-black",
  "category": "mattresses",
  "price": 4349,
  "compareAt": 5049,
  "priceFrom": true,
  "sku": "BRB26HY-S5-TXLPLM",
  "firmness": "Plush",
  "height": "15\"",
  "type": "Hybrid",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "Split Head Queen",
   "King",
   "Split Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4349,
    "compareAt": 5049
   },
   "Queen": {
    "price": 4999,
    "compareAt": 5699
   },
   "Split Head Queen": {
    "price": 5599,
    "compareAt": 6299
   },
   "King": {
    "price": 5899,
    "compareAt": 6599
   },
   "Split Head King": {
    "price": 6499,
    "compareAt": 7199
   },
   "California King": {
    "price": 5899,
    "compareAt": 6599
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-five-xcs-plush-mattress-by-simmons-7046148.jpg?v=1781582291",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-five-xcs-plush-mattress-by-simmons-7046148.jpg?v=1781582291",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-five-xcs-plush-mattress-by-simmons-2175558.jpg?v=1781582290",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-five-xcs-plush-mattress-by-simmons-6639611.jpg?v=1781582291",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-hybrid-series-five-xcs-plush-mattress-by-simmons-7178306.jpg?v=1781582291"
  ],
  "description": "Ultimate softness. Maximum contouring. The most advanced hybrid comfort. The Beautyrest Black® Series Five XCS Plush Hybrid Mattress is the most advanced model in the collection, offering the deepest level of contouring and pressure relief. It adapts instantly and more precisely to your body,…"
 },
 {
  "slug": "naples-foundation",
  "name": "Serta Naples Foundation",
  "brand": "serta",
  "category": "foundations",
  "price": 250,
  "compareAt": null,
  "priceFrom": true,
  "sku": "NAPLES-TB",
  "firmness": "-",
  "height": "-",
  "type": "Foundation",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "Queen Split",
   "King Split",
   "Cal King"
  ],
  "variants": {
   "Twin": {
    "price": 250,
    "compareAt": null
   },
   "Twin XL": {
    "price": 250,
    "compareAt": null
   },
   "Full": {
    "price": 300,
    "compareAt": null
   },
   "Queen": {
    "price": 300,
    "compareAt": null
   },
   "Queen Split": {
    "price": 250,
    "compareAt": null
   },
   "King Split": {
    "price": 500,
    "compareAt": null
   },
   "Cal King": {
    "price": 250,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/products/naples-foundation-by-serta-853003.jpg?v=1705703205",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/products/naples-foundation-by-serta-853003.jpg?v=1705703205"
  ],
  "description": "Designed as a universal match to our Serta® mattresses, the Naples Foundation helps to absorb shock, enhance durability, and provide long-lasting comfort. Working to extend the lifespan of your mattress, this flat mattress foundation offers an alternative to a box spring in a 5.5-inch low-profile…"
 },
 {
  "slug": "beautyrest-black-24-foundation",
  "name": "Beautyrest Black Foundation",
  "brand": "beautyrest-black",
  "category": "foundations",
  "price": 250,
  "compareAt": null,
  "priceFrom": true,
  "sku": "BRB24-TXLB",
  "firmness": "-",
  "height": "-",
  "type": "Foundation",
  "badge": null,
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 250,
    "compareAt": null
   },
   "Full": {
    "price": 300,
    "compareAt": null
   },
   "Queen": {
    "price": 300,
    "compareAt": null
   },
   "Split Queen": {
    "price": 500,
    "compareAt": null
   },
   "King": {
    "price": 500,
    "compareAt": null
   },
   "California King": {
    "price": 500,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-foundation-by-simmons-8709160.jpg?v=1766005150",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-foundation-by-simmons-8709160.jpg?v=1766005150",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-foundation-by-simmons-7437529.jpg?v=1766005150",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-foundation-by-simmons-3754947.jpg?v=1766005150",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/beautyrest-black-foundation-by-simmons-1233685.jpg?v=1766005150"
  ],
  "description": "Elevate the performance and longevity of your Beautyrest® Black mattress with the Simmons Beautyrest® Black Foundation-available in a 5.5\" Low Profile or 9\" Standard Profile height. Designed to prevent sagging and maintain long-term mattress support, this foundation features durable construction…"
 },
 {
  "slug": "sealy-ease-4-adjustable-bed-base",
  "name": "Sealy Ease 4.0 Adjustable Bed Base",
  "brand": "sealy",
  "category": "adjustable-bases",
  "price": 899,
  "compareAt": null,
  "priceFrom": true,
  "sku": "ADJ-EASE4-TB",
  "firmness": "-",
  "height": "-",
  "type": "Adjustable Base",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "California King"
  ],
  "variants": {
   "Twin": {
    "price": 899,
    "compareAt": null
   },
   "Twin XL": {
    "price": 899,
    "compareAt": null
   },
   "Full": {
    "price": 999,
    "compareAt": null
   },
   "Queen": {
    "price": 999,
    "compareAt": null
   },
   "King": {
    "price": 1499,
    "compareAt": null
   },
   "California King": {
    "price": 1499,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-ease-40-adjustable-bed-base-by-sealy-664292.jpg?v=1716962222",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/sealy-ease-40-adjustable-bed-base-by-sealy-664292.jpg?v=1716962222"
  ],
  "description": "Transform your bed into a relaxing retreat with the updated Sealy® EASE® 4.0 Adjustable Bed Base. Powered by the wireless remote, this power base offers all the essentials for a personalized sleep experience. The Zero Gravity preset instantly adjusts at the touch of a button to relieve back…"
 },
 {
  "slug": "serta-baselogic-gold-adjustable-base",
  "name": "Serta Baselogic Gold Adjustable Base",
  "brand": "serta",
  "category": "adjustable-bases",
  "price": 899,
  "compareAt": 999,
  "priceFrom": true,
  "sku": "ADJ-LGCGLD-TXLB",
  "firmness": "Gold",
  "height": "-",
  "type": "Adjustable Base",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Full",
   "Queen",
   "Split-Head Queen",
   "King",
   "Split-Head King",
   "California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 899,
    "compareAt": 999
   },
   "Full": {
    "price": 999,
    "compareAt": 1199
   },
   "Queen": {
    "price": 999,
    "compareAt": 1199
   },
   "Split-Head Queen": {
    "price": 1399,
    "compareAt": 1499
   },
   "King": {
    "price": 1399,
    "compareAt": 1499
   },
   "Split-Head King": {
    "price": 1799,
    "compareAt": 1899
   },
   "California King": {
    "price": 1399,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-gold-adjustable-base-by-serta-2387246.jpg?v=1767148691",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-gold-adjustable-base-by-serta-2387246.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-gold-adjustable-base-by-serta-5534883.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-gold-adjustable-base-by-serta-9982766.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-gold-adjustable-base-by-serta-3129859.jpg?v=1767148692"
  ],
  "description": "The Serta Baselogic Gold Adjustable Base enhances your nightly comfort with intuitive adjustability, zero-gravity support, and thoughtful conveniences like under-bed lighting and built-in USB ports. Designed for effortless comfort and ease of use, it’s a smart way to upgrade your sleep experience…"
 },
 {
  "slug": "serta-baselogic-platinum-adjustable-base",
  "name": "Serta Baselogic Platinum Adjustable Base",
  "brand": "serta",
  "category": "adjustable-bases",
  "price": 999,
  "compareAt": 1299,
  "priceFrom": true,
  "sku": "ADJ-LOGICPLAT-TXLB",
  "firmness": "Platinum",
  "height": "-",
  "type": "Adjustable Base",
  "badge": "Sale",
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "Split California King"
  ],
  "variants": {
   "Twin XL": {
    "price": 999,
    "compareAt": 1299
   },
   "Queen": {
    "price": 1199,
    "compareAt": 1499
   },
   "King": {
    "price": 1699,
    "compareAt": 1999
   },
   "Split California King": {
    "price": 999,
    "compareAt": 1299
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-platinum-adjustable-base-by-serta-2034014.jpg?v=1767148691",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-platinum-adjustable-base-by-serta-2034014.jpg?v=1767148691",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-platinum-adjustable-base-by-serta-4725458.jpg?v=1770384545",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-platinum-adjustable-base-by-serta-4885678.jpg?v=1770384545",
   "https://cdn.shopify.com/s/files/1/2420/9425/files/serta-baselogic-platinum-adjustable-base-by-serta-9439148.jpg?v=1770384545"
  ],
  "description": "The Serta Baselogic Platinum Adjustable Base delivers a noticeable step up in comfort with features like massage, anti-snore positioning, and enhanced presets-offering everyday luxury and recovery-focused support without moving into ultra-premium price territory. It’s a strong value choice for…"
 },
 {
  "slug": "puffy-legacy-mattress-4",
  "name": "Puffy LEGACY Mattress",
  "brand": "puffy",
  "category": "mattresses",
  "price": 4899,
  "compareAt": null,
  "priceFrom": true,
  "sku": "16TXL-HB-LGY-25",
  "firmness": "Medium",
  "height": "-",
  "type": "Hybrid",
  "badge": null,
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "Cal King",
   "Split King"
  ],
  "variants": {
   "Twin XL": {
    "price": 4899,
    "compareAt": null
   },
   "Queen": {
    "price": 6899,
    "compareAt": null
   },
   "King": {
    "price": 7899,
    "compareAt": null
   },
   "Cal King": {
    "price": 7899,
    "compareAt": null
   },
   "Split King": {
    "price": 9798,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/1740/0017/files/cart_and_checkout--legacy.png?v=1781084616",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/1740/0017/files/cart_and_checkout--legacy.png?v=1781084616"
  ],
  "description": "Official Puffy Legacy Mattress: Experience premium comfort with cloudlike support and luxury materials. Enjoy the best sleep of your life with savings today."
 },
 {
  "slug": "puffy-lux-mattress-6",
  "name": "Puffy LUX Mattress",
  "brand": "puffy",
  "category": "mattresses",
  "price": 2149,
  "compareAt": null,
  "priceFrom": true,
  "sku": "12T-HB-26",
  "firmness": "Medium",
  "height": "-",
  "type": "Hybrid",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "Cal King",
   "Split Head Queen",
   "Split Head King",
   "Split King"
  ],
  "variants": {
   "Twin": {
    "price": 2149,
    "compareAt": null
   },
   "Twin XL": {
    "price": 2449,
    "compareAt": null
   },
   "Full": {
    "price": 2699,
    "compareAt": null
   },
   "Queen": {
    "price": 2899,
    "compareAt": null
   },
   "King": {
    "price": 3099,
    "compareAt": null
   },
   "Cal King": {
    "price": 3099,
    "compareAt": null
   },
   "Split Head Queen": {
    "price": 3299,
    "compareAt": null
   },
   "Split Head King": {
    "price": 3599,
    "compareAt": null
   },
   "Split King": {
    "price": 3548,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/1740/0017/files/co-lux-image.png?v=1781084401",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/1740/0017/files/co-lux-image.png?v=1781084401",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/puffy-lux-mattress-split-head.jpg?v=1778680322"
  ],
  "description": "The best luxury hybrid memory foam mattress with contour-adapt coils for enhanced stability, temperature regulation, and unparalleled comfort."
 },
 {
  "slug": "puffy-mattress-4",
  "name": "Puffy CLOUD Mattress",
  "brand": "puffy",
  "category": "mattresses",
  "price": 1849,
  "compareAt": null,
  "priceFrom": true,
  "sku": "10T-PUFF-24",
  "firmness": "Medium",
  "height": "-",
  "type": "Memory Foam",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "Cal King",
   "Split Head Queen",
   "Split Head King",
   "Split King"
  ],
  "variants": {
   "Twin": {
    "price": 1849,
    "compareAt": null
   },
   "Twin XL": {
    "price": 2099,
    "compareAt": null
   },
   "Full": {
    "price": 2249,
    "compareAt": null
   },
   "Queen": {
    "price": 2399,
    "compareAt": null
   },
   "King": {
    "price": 2599,
    "compareAt": null
   },
   "Cal King": {
    "price": 2599,
    "compareAt": null
   },
   "Split Head Queen": {
    "price": 2799,
    "compareAt": null
   },
   "Split Head King": {
    "price": 3099,
    "compareAt": null
   },
   "Split King": {
    "price": 2848,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/1740/0017/files/cart-and-checkout--cloud_4184377f-8e53-4b2c-a80a-b5ba5fe8dc2c.jpg?v=1788463021",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/1740/0017/files/cart-and-checkout--cloud_4184377f-8e53-4b2c-a80a-b5ba5fe8dc2c.jpg?v=1788463021",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/Cloud_Front_Split_Head_2026-09-03T19-23-32.jpg?v=1788463414",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/cart-and-checkout--cloud.jpg?v=1781599977",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/puffy-cloud-mattress-split-head.jpg?v=1769152293"
  ],
  "description": "The Puffy CLOUD Mattress delivers medium comfort and dependable support, handcrafted for a cooler, more restful night's sleep. Available in multiple sizes at MattressTown with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "puffy-monarch-mattress-6",
  "name": "Puffy MONARCH Mattress",
  "brand": "puffy",
  "category": "mattresses",
  "price": 3399,
  "compareAt": null,
  "priceFrom": true,
  "sku": "16TXL-HB-26",
  "firmness": "Medium",
  "height": "-",
  "type": "Hybrid",
  "badge": null,
  "sizes": [
   "Twin XL",
   "Queen",
   "King",
   "Cal King",
   "Split Head Queen",
   "Split Head King",
   "Split King"
  ],
  "variants": {
   "Twin XL": {
    "price": 3399,
    "compareAt": null
   },
   "Queen": {
    "price": 4699,
    "compareAt": null
   },
   "King": {
    "price": 5199,
    "compareAt": null
   },
   "Cal King": {
    "price": 5199,
    "compareAt": null
   },
   "Split Head Queen": {
    "price": 5399,
    "compareAt": null
   },
   "Split Head King": {
    "price": 5699,
    "compareAt": null
   },
   "Split King": {
    "price": 5448,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/1740/0017/files/monarch-cart.png?v=1781084556",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/1740/0017/files/monarch-cart.png?v=1781084556",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/Monarch-Cart-Desktop.jpg?v=1712242863",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/PDP-Monarch-Desktop-4_c8afefc0-bad3-4ccf-a8c5-3332bb4b9adb.jpg?v=1712242863",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/PDP-Monarch-Desktop-2_ef69b978-ac21-431e-9eec-fc4f9c54b269.jpg?v=1712242863"
  ],
  "description": "The Puffy MONARCH Mattress delivers medium comfort and dependable support, handcrafted for a cooler, more restful night's sleep. Available in multiple sizes at MattressTown with local delivery, professional set-up and old-mattress removal."
 },
 {
  "slug": "puffy-royal-mattress",
  "name": "Puffy Royal Mattress",
  "brand": "puffy",
  "category": "mattresses",
  "price": 2499,
  "compareAt": null,
  "priceFrom": true,
  "sku": "14T-HB-26",
  "firmness": "Medium",
  "height": "-",
  "type": "Hybrid",
  "badge": null,
  "sizes": [
   "Twin",
   "Twin XL",
   "Full",
   "Queen",
   "King",
   "Cal King",
   "Split Head Queen",
   "Split Head King",
   "Split King"
  ],
  "variants": {
   "Twin": {
    "price": 2499,
    "compareAt": null
   },
   "Twin XL": {
    "price": 2849,
    "compareAt": null
   },
   "Full": {
    "price": 3549,
    "compareAt": null
   },
   "Queen": {
    "price": 3799,
    "compareAt": null
   },
   "King": {
    "price": 4099,
    "compareAt": null
   },
   "Cal King": {
    "price": 4099,
    "compareAt": null
   },
   "Split Head Queen": {
    "price": 4199,
    "compareAt": null
   },
   "Split Head King": {
    "price": 4599,
    "compareAt": null
   },
   "Split King": {
    "price": 4348,
    "compareAt": null
   }
  },
  "image": "https://cdn.shopify.com/s/files/1/1740/0017/files/puffy-royal-mattress-image-v2_e4fbf70a-9203-4089-8712-7f6fc412fffb.jpg?v=1781600340",
  "gallery": [
   "https://cdn.shopify.com/s/files/1/1740/0017/files/puffy-royal-mattress-image-v2_e4fbf70a-9203-4089-8712-7f6fc412fffb.jpg?v=1781600340",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/puffy-royal-mattress_2e90956f-cf9d-4f95-b7c0-9d5977639a3d.jpg?v=1711719053",
   "https://cdn.shopify.com/s/files/1/1740/0017/files/puffy-royal-mattress.jpg?v=1711719053",
   "https://cdn.shopify.com/s/files/1/1740/0017/products/royal-gallery-new-render-d_1920x_8f41f381-1180-4cfe-92a4-870df8a021e9.webp?v=1711719053"
  ],
  "description": "Ranked the Best Luxury Mattress , indulge in unparalleled comfort and superior cooling, crafted with specialized memory foam and coils for an exceptional sleep experience."
 }
];
